<template>
<div :class="rating ? 'product-rating-block accordion is-active' : 'product-rating-block accordion'">
  <div class="accordion-header toggle"  @click.prevent="rating = !rating">
    <p>Ratings and Reviews</p>
    <button class="toggle" aria-label="toggle"><img
        src="@/assets/img/icon-arrow-down.svg" alt="Toggle Arrow"></button>
  </div>
  <div class="accordion-body">
    <div class="accordion-content">
      <loading v-if="is_loading"></loading>
      <div
        v-else
        class="total-impressions-block is-flex justify-content-between align-items-center mb30">
        <div class="title mb0">Overall Impressions</div>
        <div class="impressions-stars-count is-flex align-items-center">
            
          <star-rating
            v-if="product_reviews.ratings_average"
            :star-size="18"
            :increment="0.1"
            v-model="product_reviews.ratings_average.ratings_rate_this_product"
            read-only
            :show-rating="false"
          ></star-rating>

          <div class="avg-rating ml15" v-if="product_reviews">{{ product_reviews.ratings_average && product_reviews.ratings_average.ratings_rate_this_product ? product_reviews.ratings_average.ratings_rate_this_product.toFixed(2) : '0' }}</div>
        </div>
      </div>
          
      <div class="feeling-block mb30">

        <div class="feelings">
          <div class="columns is-flex-mobile is-flex-wrap">
            <div class="column is-6-mobile is-4-tablet">
              <div class="feeling-text">Relaxed</div>
              <div class="feeling-bar">
                <progress class="progress" :value="getTagAverage('Relaxed', product_reviews.tags_average)"
                  max="100"></progress>
              </div>
            </div>
            <div class="column is-6-mobile is-4-tablet">
              <div class="feeling-text">Serene</div>
              <div class="feeling-bar">
                <progress class="progress" :value="getTagAverage('Serene', product_reviews.tags_average)"
                  max="100"></progress>
              </div>
            </div>
            <div class="column is-6-mobile is-4-tablet">
              <div class="feeling-text">Sleepy</div>
              <div class="feeling-bar">
                <progress class="progress" :value="getTagAverage('Creative', product_reviews.tags_average)"
                  max="100"></progress>
              </div>
            </div>
          </div>
        </div>
        <div class="feelings">
          <div class="columns is-flex-mobile">
            <div class="column is-6-mobile is-4-tablet">
              <div class="feeling-text">Uplifted</div>
              <div class="feeling-bar">
                <progress class="progress" :value="getTagAverage('Energetic', product_reviews.tags_average)"
                  max="100"></progress>
              </div>
            </div>
            <div class="column is-6-mobile is-4-tablet">
              <div class="feeling-text">Focused</div>
              <div class="feeling-bar">
                <progress class="progress" :value="getTagAverage('Alert', product_reviews.tags_average)"
                  max="100"></progress>
              </div>
            </div>
            <div class="column is-6-mobile is-4-tablet">
              <div class="feeling-text">Happy</div>
              <div class="feeling-bar">
                <progress class="progress" :value="getTagAverage('Happy', product_reviews.tags_average)"
                  max="100"></progress>
              </div>
            </div>
          </div>
        </div>
        <div class="feelings">
          <div class="columns is-flex-wrap" v-if="product_reviews.ratings_like_dislike">
            <div class="column is-flex-mobile justify-content-between align-items-center">
              <div class="feeling-text">Appearance</div>
              <div class="reaction-btns is-flex">
                <div
                  class="disable-hover-effect dislike-btn is-flex is-borderless is-radiusless is-shadowless mr10">
                  <div class="dislike-count">{{ product_reviews.ratings_like_dislike.ratings_appearance.dis_like }}</div>
                </div>
                <div
                  class="disable-hover-effect like-btn is-flex is-borderless is-radiusless is-shadowless">
                  <div class="like-count">{{ product_reviews.ratings_like_dislike.ratings_appearance.like }}</div>
                </div>
              </div>
            </div>
            <div class="column is-flex-mobile justify-content-between align-items-center">
              <div class="feeling-text">Taste</div>
              <div class="reaction-btns is-flex">
                <div
                  class="disable-hover-effect dislike-btn is-flex is-borderless is-radiusless is-shadowless mr10">
                  <div class="dislike-count">{{ product_reviews.ratings_like_dislike.ratings_taste.dis_like }}</div>
                </div>
                <div
                  class="disable-hover-effect like-btn is-flex is-borderless is-radiusless is-shadowless">
                  <div class="like-count">{{ product_reviews.ratings_like_dislike.ratings_taste.like }}</div>
                </div>
              </div>
            </div>
            <div class="column is-flex-mobile justify-content-between align-items-center">
              <div class="feeling-text">Smell</div>
              <div class="reaction-btns is-flex">
                <div
                  class="disable-hover-effect dislike-btn is-flex is-borderless is-radiusless is-shadowless mr10">
                  <div class="dislike-count">{{ product_reviews.ratings_like_dislike.ratings_smell.dis_like }}</div>
                </div>
                <div
                  class="disable-hover-effect like-btn is-flex is-borderless is-radiusless is-shadowless">
                  <div class="like-count"> {{ product_reviews.ratings_like_dislike.ratings_smell.like }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="reviews-block">
        <div class="title mb20">Reviews</div>
        <div
          class="write-review is-flex justify-content-between align-items-end mb30">
            <router-link class="no-underline" :to="{ name: 'ProductWriteReview', params: { product_slug: product.master_pid } }">
              <button href="#" class="button review-btn"><img
                src="@/assets/img/icon-write.svg" class="mr10">Write a
              review </button>
            </router-link>
            <router-link :to="{ name: 'ProductReview', params: { product_slug:  product.master_pid } }" class="view-all has-text-weight-semibold has-text-right">
              View all <span>({{ product_reviews.total_reviews ? product_reviews.total_reviews : 0 }})</span>
            </router-link>
        </div>
        <div class="reviews" v-if="product_reviews.reviews">

          <div class="review" v-bind:key="'review_' + index"  v-for="(review, index) in product_reviews.reviews">
            <div
              class="review-data-block is-flex justify-content-between">
              <div class="review-stars">
                <star-rating
                  v-if="review.ratings"
                  :star-size="18"
                  :increment="0.1"
                  v-model="review.ratings.ratings_rate_this_product"
                  read-only
                  :show-rating="false"
                ></star-rating> 
              </div>
              <div class="review-meta">
                <div class="date">{{ formatReviewDate(review.review_date) }}</div>
                <div class="reviewer">{{ displayReviewUser(review.user) }}</div>
              </div>
            </div>

            <div class="review-title has-text-weight-semibold mb10" v-text="review.ratings.review_title"></div>
            <div class="review-desc" v-text="review.ratings.review_description"></div>
          </div>

          <div class="review" v-if="product_reviews.reviews && product_reviews.reviews.length < 1">
            <div class="review-title has-text-weight-semibold mb10">No reviews.</div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Env from '@/env';
import moment from 'moment';
import StarRating from "vue-star-rating";

export default {
   name: 'ProductDetailRating', // Not in use
  components: {
    StarRating,
  },
 
  data() {
    return {
      is_loading: false,
      rating: false,
      product_slug: '',
      product_reviews: {},
    };
  },
  mounted() {
    this.fetchProductReviews();
  },
  props: ['product'],
  methods: {
    /**
     * Display user
     */
    displayReviewUser(user) {
      if( typeof user  != 'string'){
        return user.first_name  + ' ' + user.last_name;
      }
      return user;
    },
    /**
     * Format review date
     */
    formatReviewDate(reviewdate) {
      return moment(reviewdate.split('.')[0]).format('YYYY MMM D, h:mm A')
    },
    /**
     * Fetch product rating and review
     */
    fetchProductReviews() {
      this.is_loading = true;
      const url = `${Env.reviewUrl}/api/v1/reviews/products/${this.product.master_pid}`;
      this.getApi(url, {
        "app-id": Env.reviewAppId,
        "app-secret": Env.reviewAppSecret,
      })
      .then( res => {
        this.is_loading = false;
        this.product_reviews = res.data.payload;
      })
      .catch(err => {
        this.is_loading = false;
        console.log('Unable to fetch product reviews')
      })
    },

    /**
     * Get tag average
     */
    getTagAverage(keyName, arr){
      let obj = _.find(arr, { key: keyName});
      if(obj == undefined){
        return '-';
      }
      return obj.value * 100;  
    }
  },
};
</script>

<style scoped>
.like-btn {
    width: 59px;
    padding-left: 25px;
}
.disable-hover-effect{
  color: #363636;
  cursor: pointer;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-bottom: calc(0.375em - 1px);
  padding-left: 0.75em;
  padding-right: 0.75em;
  padding-top: calc(0.375em - 1px);
  text-align: center;
  white-space: nowrap;
  align-items: center;
}
.reviews {
    height: 500px;
    overflow-y: auto;
}
</style>

